import { useState } from 'react'
import { converterComissao } from '../importacao/validacao'

// A chave e de quem chama, nao deste componente: a importacao cobra de produto
// que ainda nao existe no banco (chave = codigo) e a tela de precos cobra de
// produto gravado (chave = produto_id). Deixar o componente adivinhar qual dos
// dois usar foi o que amarrou a importacao a um canal so.
export interface AlvoDeComissao {
  chave: string
  codigo: string
  descricao: string
}

export default function PreenchimentoComissao({
  pendentes,
  nomeTabela,
  valores,
  aoMudar,
  aoAplicarATodos,
  aoConfirmar,
  textoConcluir = 'Concluir importação',
  enviando = false,
}: {
  pendentes: AlvoDeComissao[]
  nomeTabela: string
  valores: Record<string, string>
  aoMudar: (chave: string, texto: string) => void
  aoAplicarATodos: (texto: string) => void
  aoConfirmar: () => void
  textoConcluir?: string
  // trava o botao de concluir enquanto uma gravacao ja esta em voo -- guarda de
  // reentrancia contra toque duplo (quem chama controla o estado; aqui so desliga
  // o botao). Default false preserva o comportamento de quem nao usa a prop.
  enviando?: boolean
}) {
  const [emMassa, setEmMassa] = useState('')
  const estiloCampo = 'w-20 border border-slate-300 rounded-lg px-2 py-1 text-sm text-right'

  const faltam = pendentes.filter(
    (p) => converterComissao((valores[p.chave] ?? '').trim()) === null,
  ).length

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 space-y-3">
      {/* O titulo diz o que fazer, nao so o que aconteceu -- pedido da usuaria
          ao validar o passo (Achado 5). O nome da tabela desceu para o texto. */}
      <h3 className="font-medium text-slate-800">
        {pendentes.length} produto(s) sem comissão, digite o percentual
      </h3>
      <p className="text-sm text-slate-600">
        São produtos com preço em “{nomeTabela}”. Sem comissão definida, eles seriam vendidos a 0%
        sem aviso. Zero é uma resposta válida — desde que você a escolha.
      </p>

      <div className="flex items-end gap-2 border-b border-slate-100 pb-3">
        <div>
          <label htmlFor="massa" className="block text-xs text-slate-500 mb-0.5">
            Aplicar a todos
          </label>
          <input
            id="massa"
            value={emMassa}
            onChange={(e) => setEmMassa(e.target.value)}
            inputMode="decimal"
            placeholder="ex.: 3"
            className={estiloCampo}
          />
        </div>
        <button
          type="button"
          onClick={() => aoAplicarATodos(emMassa)}
          disabled={converterComissao(emMassa.trim()) === null}
          className="bg-slate-200 text-slate-700 rounded-lg px-3 py-1.5 text-sm disabled:opacity-50"
        >
          aplicar
        </button>
      </div>

      <ul className="space-y-1 max-h-80 overflow-y-auto">
        {pendentes.map((alvo) => {
          const texto = valores[alvo.chave] ?? ''
          const vazio = converterComissao(texto.trim()) === null
          return (
            <li key={alvo.chave} className="flex items-center justify-between gap-2">
              <span className="text-sm text-slate-700 truncate">
                {alvo.codigo} — {alvo.descricao}
              </span>
              <input
                aria-label={`Comissão de ${alvo.codigo}`}
                value={texto}
                onChange={(e) => aoMudar(alvo.chave, e.target.value)}
                inputMode="decimal"
                className={vazio ? `${estiloCampo} border-amber-400` : estiloCampo}
              />
            </li>
          )
        })}
      </ul>

      <button
        type="button"
        onClick={aoConfirmar}
        disabled={faltam > 0 || enviando}
        className="w-full bg-teal-700 text-white rounded-lg py-2 font-medium disabled:opacity-50"
      >
        {faltam > 0 ? `Faltam ${faltam}` : textoConcluir}
      </button>
    </div>
  )
}
